var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 61 28",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 61 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paso1",
    transform: "translate(-227 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(227 237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(31 9)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 9,
    id: "mask-2_00000167396601121249399960000016991234732457089726_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000029748797086090715000000016554213219444249767_",
    className: "st1",
    d: "M0 0h30v9H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M24.6 0H0v9h8.4l.8-1.5h3.6l1.7-2.9s1.3 1.9 1.9 2.9h2.8L21 5.3l1.2 2.2h2.4L30 5.3 24.6 0z",
    mask: "url(#mask-2_00000167396601121249399960000016991234732457089726_)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000134236376113531028850000015592001291686032525_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 28
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 28,
    id: "mask-4_00000114777236518113058350000006727873057894972046_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_00000134236376113531028850000015592001291686032525_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_00000016775918325154354040000000003737858382592932_",
    className: "st1",
    d: "M0 0h31v28H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M7.2 18.3C4.9 18.3 3 16.4 3 14s1.9-4.3 4.2-4.3c2.3 0 4.2 1.9 4.2 4.3.1 2.4-1.8 4.3-4.2 4.3zM31 7.8h-4.8C24 3.2 19.3 0 13.8 0 6.2 0 0 6.3 0 14s6.2 14 13.8 14c5.4 0 10.1-3.2 12.4-7.8H31V7.8z",
    mask: "url(#mask-4_00000114777236518113058350000006727873057894972046_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#01c1cf"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.7e9edb7e3443f10e7b6335986f81dc98.svg";
export { ForwardRef as ReactComponent };